import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { configData } from "../../../../../src/config/systemconfigurationconstants";
import * as AWS from 'aws-sdk';
import { ToastContainer, toast } from "react-toastify";
import { useEncryption } from '../../../../customHooks/useEncryption';
let errorbucketname;
let errorfileName;
let successrpmFilename;
const UploadRuleConfirmation = ({ show, handleClose, ruleFileName, currentRpmFileName, ruleType, showUploadRuleSheet, configjson, applyImmediately, startDate, endDate, file, enableloader, disableloader, displayuploadsection, displayErrorPopup }) => {
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const [dotloader, setDotLoader] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [errorPopup, setErrorPopup] = useState(false);
    const [bucketname, setBucketname] = useState();
    const [fileName, setFileName] = useState();
    const [errorMsg, setErrorMsg] = useState();
    const handleCheckboxChange = (e) => {
        setIsConfirmed(e.target.checked);
    };
    const uploadRules = () => {
        setDotLoader(true);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const data = {
            Task: "CompareRPMData",
            ActionType: "SAVE",
            CSN: configjson.IDXCSN,
            UCSN: configjson.IDXUCSN,
            BucketName: configjson.IDXBucket,
            FilterLevel: 4,
            RuleTypeId: ruleType,
            RuleFileNameWithPath: 'TempFiles/' + ruleFileName,
            CurrentRPMWithPath: 'TempFiles/' + currentRpmFileName,
            UserName: localStorage.getItem("UserName").trim(),

        };
        const params = {
            FunctionName: "CompareAndSaveRPM",
            Payload: JSON.stringify(data)
        };
        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
            } else {
                const parsedPayload = JSON.parse(data.Payload.toString());
                if (parsedPayload.statusCode === 200) {
                    const parsedBody = JSON.parse(parsedPayload.body);
                    readJsonFileAfterUpload(parsedBody.JsonBucketName, parsedBody.JsonFileNameWithPath)
                }
                else {
                    handleClose();
                    setTimeout(() => {
                        setDotLoader(false);
                    }, 1000);
                }
            }
        })
    }
    const readJsonFileAfterUpload = async (bucketname, filename) => {
        setBucketname(bucketname);
        setFileName(filename);
        setDotLoader(true);
        errorbucketname = bucketname;
        errorfileName = filename;

        // setDotLoader(true);
        const splitsname = filename.split('/');
        successrpmFilename = splitsname[2]
        let mergeKeyFile = bucketname + '/' + splitsname[0] + '/' + splitsname[1];

        AWS.config.credentials = new AWS.Credentials({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk'))
        });

        const s3 = new AWS.S3({ signatureVersion: 'v4', region: configData.LAMBDA_REGION });

        const s3Data = await s3.getObject({
            Bucket: mergeKeyFile,
            Key: splitsname[2],
            IfModifiedSince: new Date(0)
        }).promise();

        const dataBuffer = new Uint8Array(s3Data.Body);
        const dataJson = new TextDecoder('utf-8').decode(dataBuffer);
        const getdatajsondata = JSON.parse(dataJson);
        console.log(getdatajsondata);
        if (!getdatajsondata.Result) {
            setErrorMsg(getdatajsondata.ResultMessage);
            setErrorPopup(true);
            showUploadRuleSheet();
            setTimeout(() => {
                setDotLoader(false);
            }, 1000);
        }
        else {
            uploadresponserpm(getdatajsondata)
        }
        // setRpmTableValues(getdatajsondata)
        // setUploadDisplayHide(true)
        // setTimeout(() => {
        //     setDotLoader(true);
        // }, 1000);
    }
    const uploadresponserpm = async (getdatajsondata) => {
        setDotLoader(true);
        AWS.config.update({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            region: configData.LAMBDA_REGION,
        });

        const s3 = new AWS.S3();
        const params = {
            Bucket: configjson.Bucket + '/' + "TempFiles",
            Key: successrpmFilename,
            Body: JSON.stringify(getdatajsondata), // convert JSON to string
            ContentType: "application/json", // correct MIME type
        };

        try {
            const data = await s3.upload(params).promise();
            console.log('Upload success:', data.Location);
            saverpm();
        } catch (err) {
            // setDotLoader(true);
            console.error('Upload error:', err);
            setTimeout(() => {
                setDotLoader(false);
            }, 1000);
        }
    };
    const saverpm = async () => {
        // setDotLoader(false);
        setDotLoader(true);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const payloadData = {
            Command: configData.SAVE_RPM_DATA,
            RPMJsonPath: "TempFiles" + "/" + successrpmFilename,
            ClientShortName: configjson.ClientShortName,
            UseCaseShortName: configjson.UseCaseShortName,
            BucketName: configjson.RuleBucket,
            RuleFileName: file.name,
            UserName: localStorage.getItem("UserName").trim(),
            RuleTypeId: ruleType,
            IsAppliedImmediately: applyImmediately,
            ApplicableFrom: startDate,
            ApplicableTo: endDate,
            SecurityId: "",
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: ""
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(payloadData)
        };

        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                    setTimeout(() => {
                        setDotLoader(false);
                    }, 1000);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                const parsedBody = JSON.parse(parsedPayload.body);
                copyFilesToS3(JSON.parse(parsedBody.Output));
            }
            else {
                toast.error("Rule Upload Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
                // disableloader();
                // setDotLoader(false);
            }
        } catch (error) {
            setTimeout(() => {
                setDotLoader(false);
            }, 1000);
            toast.error("Rule Upload Failed", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            // disableloader();
            // setDotLoader(false);
            console.error('Error in getCurrentRpm:', error);
        }

        // setDotLoader(false);
        // try {
        //     const parsedBody = await invokeLambda(configData.GET_CONFIG_FOR_UI, {
        //         // ...lambdaConfig,
        //         // SecurityToken: localStorage.getItem('SecurityToken'),
        //         ClientShortName: localStorage.getItem('ClientShortName').trim(),
        //         UseCaseShortName: localStorage.getItem('UseCaseShortName').trim()
        //     });

        //     if (parsedBody.Status) {
        //         setUploadIdxBucket(parsedBody.IDXBucket);
        //         // setUserDetails(parsedBody.UserInfo)
        //         // setUseCaseListForUserCreation(parsedBody.UseCaseClientInfo[0].UseCase)
        //         // setUserRoleListForUserCreation(parsedBody.UserRoleInfo)
        //         // setUserProviderForUserCreation(parsedBody.Prvdrslst)
        //         // setTimeout(() => {
        //         //     setDotLoader(true);
        //         // }, 1000);
        //     } else {
        //         // setDotLoader(false);
        //     }
        // } catch (err) {
        //     // Handle error if needed
        //     // setDotLoader(false);

        // }
    }
    const copyFilesToS3 = async (parsedBodyforsaverpm) => {
        setDotLoader(true);
        const filePath = parsedBodyforsaverpm.FileNameWithPath;
        const pathParts = filePath.split('/');
        pathParts[0] = pathParts[0].replace(/\s+/g, '');
        const updatedPath = pathParts.join('/');

        console.log(updatedPath);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });
        const payloadData = {
            Command: configData.COPY_FILE_TO_S3,
            SourceBucket: configjson.IDXBucket,
            SourceKey: 'TempFiles/' + ruleFileName,
            DestinationBucket: configjson.RuleBucket,
            DestinationKey: updatedPath

        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(payloadData)
        };
        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                    setTimeout(() => {
                        setDotLoader(false);
                    }, 1000);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                const parsedBody = JSON.parse(parsedPayload.body);
                toast.success('v' + parsedBodyforsaverpm.NewVersionId + " " + "Rulesheet uploaded successfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
                displayuploadsection();
            }
            else {
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
                toast.error("Rule Upload Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                // disableloader();
                displayuploadsection();
                // setDotLoader(false);
            }
        } catch (error) {
            setTimeout(() => {
                setDotLoader(false);
            }, 1000);
            // setDotLoader(false);
            toast.error("Rule Upload Failed", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            // disableloader();
            displayuploadsection();
            console.error('Error in getCurrentRpm:', error);
        }
    }
    const downloadErrorRuleFile = () => {
        setDotLoader(true);
        AWS.config.credentials = new AWS.Credentials({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk'))
        });
        const params = {
            Bucket: errorbucketname,
            Key: errorfileName,
            Expires: 300 // The URL will now expire in 5 minutes (300 seconds)
        };
        const s3 = new AWS.S3({
            region: 'us-east-1',
        });
        var url = s3.getSignedUrl('getObject', params);
        window.open(url, '_blank');
        setTimeout(() => {
            setDotLoader(false);
        }, 1000);
        toast.success("Error Details Download successfully", {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        handleClose();
        displayuploadsection();
    }
    return (
        <Fragment>
            {/* <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                {!errorPopup && <Modal.Header closeButton>
                    <Modal.Title>Upload Rule Sheet</Modal.Title>
                </Modal.Header>}
                {!errorPopup ? <Modal.Body>
                    <p>Are you sure you want to upload the rule sheet?</p>
                    <Form.Check
                        type="checkbox"
                        label="Confirm upload"
                        checked={isConfirmed}
                        onChange={handleCheckboxChange}
                    />
                </Modal.Body> : <Modal.Body>
                    <p className="text-danger text-uppercase"> <i class="ri-error-warning-fill"></i> TO Create a Client Field required details are missing so can't create client field</p>
                    <p>Do you want to Download the result</p>
                </Modal.Body>}
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => { handleClose(); setIsConfirmed(false) }}>
                        Cancel
                    </Button>
                    {!errorPopup ? <Button
                        variant="primary"
                        size="sm"
                        onClick={uploadRules}
                        disabled={!isConfirmed}
                    >
                        Ok
                    </Button> : <Button
                        variant="primary"
                        size="sm"
                        onClick={downloadErrorRuleFile}
                    >
                        Ok
                    </Button>}
                </Modal.Footer>
            </Modal> */}
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                {!errorPopup && <Modal.Header>
                    <Modal.Title>Upload Rule Sheet</Modal.Title>
                </Modal.Header>}

                <Modal.Body>
                    {dotloader ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }}>
                            <div className="loader"></div>
                        </div>
                    ) : (
                        !errorPopup ? (
                            <>
                                <p>Are you sure you want to upload the rule sheet?</p>
                                <Form.Check
                                    type="checkbox"
                                    label="Confirm upload"
                                    checked={isConfirmed}
                                    onChange={handleCheckboxChange}
                                />
                            </>
                        ) : (
                            <>
                                <p className="text-danger text-uppercase">
                                    <i className="ri-error-warning-fill"></i> {errorMsg}
                                </p>
                                <p>Do you want to Download the result?</p>
                            </>
                        )
                    )}
                </Modal.Body>

                {!dotloader && (
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={() => { handleClose(); setIsConfirmed(false); }}>
                            Cancel
                        </Button>
                        {!errorPopup ? (
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={uploadRules}
                                disabled={!isConfirmed}
                            >
                                Ok
                            </Button>
                        ) : (
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={downloadErrorRuleFile}
                            >
                                Ok
                            </Button>
                        )}
                    </Modal.Footer>
                )}
            </Modal>

        </Fragment>
    );
};

export default UploadRuleConfirmation;